const PER_PAGE = 5;
let page = 0;
let selected = {
  ages: 'all',
  location: 'all',
};

export const codeProjects = () => {
  // hide pagination button when all unfiltered posts are visible
  const togglePaginationVisibility = () => {
    const hasMorePosts =
      $('.code-projects .wp-block-post.hidden:not(.filtered)').length > 0;

    $('.code-projects .posts-pagination').toggleClass('hidden', !hasMorePosts);
  };

  // accordion
  const $headings = $('.code-projects__list-item > .wp-block-post-title');
  $headings.on('click', function () {
    $(this).parent()[0]?.toggleAttribute('open');
  });

  // filter
  $('.code-projects select').on('change', function () {
    const type = this.getAttribute('name');
    selected[type] = this.value;

    $('.code-projects__list-item').each((_, item) => {
      const ages = item.getAttribute('data-ages')?.split(',') || [];
      const location = item.getAttribute('data-location')?.split(',') || [];

      const isVisible =
        (selected.ages === 'all' || ages.includes(selected.ages)) &&
        (selected.location === 'all' || location.includes(selected.location));

      $(item).toggleClass('filtered', !isVisible);
    });

    // paginate unfiltered posts
    const $unfilteredItems = $('.code-projects__list-item:not(.filtered)');
    $unfilteredItems.slice(0, PER_PAGE).removeClass('hidden');
    $unfilteredItems.slice(PER_PAGE).addClass('hidden');

    togglePaginationVisibility();
  });

  // on view more click, show next posts up to the per page limit
  $('.code-projects .posts-pagination > .button').on('click', function () {
    $('.code-projects__list-item.hidden:not(.filtered)')
      .slice(0, PER_PAGE)
      .removeClass('hidden');

    togglePaginationVisibility();
    page++;
  });
};
